import api from './api';
import environment from './environment';
import legacy from './legacy';
import mui from './mui';

export default {
  api,
  environment,
  legacy,
  mui,
};
